import PropTypes from 'prop-types';

import {useSubscriber} from '@stubhub/pubsub-utils';
import {useRiskifiedGo} from '@stubhub/react-riskified';

const {HOME_EVENTS, ENTITY_EVENTS, SEARCH_EVENTS, EVENT_PAGE} = require('./track-enum');

const RiskifiedListener = (_, context) => {
  const {logger} = context;
  const sendRiskified = useRiskifiedGo({}, logger);

  const riskifiedHandlers = {
    [HOME_EVENTS.LOADED]: sendRiskified,
    [ENTITY_EVENTS.LOADED]: sendRiskified,
    [SEARCH_EVENTS.LOADED]: sendRiskified,
    [EVENT_PAGE.LOADED]: sendRiskified,
  };

  useSubscriber(HOME_EVENTS.MAIN, riskifiedHandlers);
  useSubscriber(ENTITY_EVENTS.MAIN, riskifiedHandlers);
  useSubscriber(SEARCH_EVENTS.MAIN, riskifiedHandlers);
  useSubscriber(EVENT_PAGE.MAIN, riskifiedHandlers);

  return null;
};

RiskifiedListener.contextTypes = {
  logger: PropTypes.object,
};

export default RiskifiedListener;
